import { ListNode } from "components/objectTree/types";

import { INDEX_SUFFIX_PATTERN, LEVEL_INDENT_BASE, LEVEL_INDENT_INCREMENT } from "../constants";

export function formatNodeDisplayName<T>(item: ListNode<T>): string {
    // Keep the trailing " (N)" index on an individual indexed row so duplicates of the same
    // name stay distinguishable and visibly ordered by their index. The collapsed group row
    // (which carries a count badge) and non-indexed rows still show the clean name.
    const isExpandedIndexedRow = Boolean(item.node.groupKey) && !item.nodeGroup;
    const baseName = isExpandedIndexedRow ? item.node.name : removeIndexSuffix(item.node.name);

    const childPath = item.nodes?.map((n) => `/${removeIndexSuffix(n.name)}`).join("") ?? "";

    return baseName + childPath;
}

/**
 * Strips search-db's auto-generated " (N)" index suffix from an object name
 * (e.g. "Upholstery Arms (69)" -> "Upholstery Arms"). Applied to the collapsed group
 * representative, collapsed child-path segments, and non-indexed names. Individual
 * (expanded) indexed rows keep the suffix so they can be told apart and ordered by index.
 * Names without the suffix pass through unchanged.
 */
function removeIndexSuffix(name: string): string {
    const match = name.match(INDEX_SUFFIX_PATTERN);
    return match ? match[1] : name;
}

export function getGroupCountLabel<T>(item: ListNode<T>): string {
    const count = item.nodeGroup?.length ?? 0;
    const hasMore = item.isLast && item.parent?.hasMoreChildren;
    return `${count}${hasMore ? "+" : ""}`;
}

export function calculateTreeIndentation(level: number): number {
    if (level === 0) {
        return 0;
    }
    return LEVEL_INDENT_BASE + (level - 1) * LEVEL_INDENT_INCREMENT;
}
